const storeName = 'AUTH';
export default {
    AFTER_LOGOUT: `${storeName}.AFTER_LOGOUT`,
    CHECK_USER_TOKEN: `${storeName}.CHECK_USER_TOKEN`,
    DO_LOGIN: `${storeName}.DO_LOGIN`,
    DO_LOGOUT: `${storeName}.DO_LOGOUT`,
    GET_CLIENT_CREDENTIALS: `${storeName}.GET_CLIENT_CREDENTIALS`,
    GET_RES_OWNER_PWD_FLOW: `${storeName}.GET_RES_OWNER_PWD_FLOW`,
    INITIALIZE_DATA_FIELD: `${storeName}.INITIALIZE_DATA_FIELD`,
    LOGIN_DONE: `${storeName}.LOGIN_DONE`,
    LOGIN_PROFILE_READY: `${storeName}.LOGIN_PROFILE_READY`,
    RESET_PASSWORD: `${storeName}.RESET_PASSWORD`,
    SET_DATA_FIELD: `${storeName}.SET_DATA_FIELD`,
    SET_ERROR: `${storeName}.SET_ERROR`,
    SET_LOADING: `${storeName}.SET_LOADING`,
    SET_LOGIN_POPOVER_NAME: `${storeName}.SET_LOGIN_POPOVER_NAME`,
    SET_STOP_ERROR_RESET_PROPAGATION: `${storeName}.STOP_ERROR_RESET_PROPAGATION`,
    SOCIAL_REGISTRATION: `${storeName}.SOCIAL_REGISTRATION`,
    STORE_SELECTED: 'STORE_SELECTED',
    STORE: `${storeName}.STORE`,
    SET_FOCUSED: `${storeName}.SET_FOCUSED`,
    SET_UNFOCUSED: `${storeName}.SET_UNFOCUSED`,
    SET_FB_APP_ID: `${storeName}.SET_FB_APP_ID`,
};
